let divStub;

/**
 * html转纯文本（用于xss过滤），仅用于预期输出为文本的情况，性能比完备地实现xss高10+倍
 * IM项目内部使用足够（IM的预期输出为纯文本，不允许出现HTML代码）
 * 如果需要完备的xss过滤或html格式输出，可以参考@sea https://github.com/leizongmin/js-xss
 * @param html
 * @returns {string}
 */
module.exports = function (html) {
  divStub = divStub || document.createElement('div');

  if (divStub.textContent !== undefined) {
    divStub.textContent = html;
  } else {
    // for ie9-
    divStub.innerText = html;
  }

  return divStub.innerHTML.replace(/&amp;/g, '&');
};
